
export class SearchQueryField {
    name = '';
    isSelected = false;
    field: string;

    constructor(name, field?, isSelected = false) {
        this.name = name;
        this.field = field || name;
        this.isSelected = isSelected;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SearchQueryField.ts